import React from "react";
import { Link } from "react-router-dom";
import { TripCard, Pagination } from "../components";
import { useTrips } from "../hooks/trip_hooks";
import { Tabs, TextInput, rem, Grid, Button } from "@mantine/core";

// Icon
import {
  IconPlus,
  IconSearch,
  IconPlaneTilt,
  IconBed,
  IconCar,
  IconSoup,
  IconCalendarStats,
  IconMapPinCheck,
  IconShip,
  IconWalk,
  IconParkingCircle,
  IconTrain,
  IconLuggage,
  IconAirBalloon,
  IconPlane,
} from "@tabler/icons-react";
const MyTripsPanel = () => {
  const { trips, numOfPages, setPage } = useTrips();
  const icon = (
    <IconSearch stroke={2} style={{ width: rem(16), height: rem(16) }} />
  );
  const handlePageChange = (val) => {
    setPage(val);
  };
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

  return (
    <div>
      <div className="mt-6 md:mt-0">
        <div className="w-full flex justify-between items-center flex-wrap py-5 gap-7">
          <Link
            to={`/trip/create`}
            className={`flex items-center justify-center gap-3  dark:border-gray-600 text-[#0782c5] dark:text-sky-500 font-semibold text-base  mt-[-10px] cursor-pointer`}
          >
            <span className="border rounded-full border-[#0782c5] ">
              <IconPlus stroke={2} />
            </span>
            Thêm chuyến đi
          </Link>
          <TextInput
            className="w-[24%] "
            mt=""
            rightSectionPointerEvents="none"
            rightSection={icon}
            label=""
            placeholder="Tìm kiếm"
          />
        </div>
      </div>

      {trips?.length < 1 ? (
        <span className=" mt-[20px] h-full ">
          {/* <img src="https://i.pinimg.com/564x/d8/47/5c/d8475c216519756afd41a3473e5f5fed.jpg" alt="" className="rounded-lg" /> */}

          <div class="flex mx-auto w-[70%] ">
            <svg
              viewBox="0 0 712 342"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="trips-list-group-no-trips_negativeStateMargins_MF_Mz"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M613.1 322L595 307.6C584.7 300.1 571.2 298.9 559.7 304.4L551.4 308.4C544.7 311.6 537.1 312.5 529.9 310.8L512 306.8C505.4 305.3 498.6 305.9 492.3 308.4C483.4 312 476.9 314.3 472.6 315.4C467 316.8 459.8 319.8 451 322C451.1 322 607.3 321.8 613.1 322Z"
                fill="#DFF0FC"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M559.4 322C559.2 322 559 321.9 558.8 321.8L550.6 312.5L535.9 321.9C535.7 322 535.4 322.1 535.2 322C535 321.9 534.8 321.7 534.8 321.5L535.9 295.7C535.9 295.4 536.1 295.2 536.4 295.2C536.7 295.1 537 295.2 537.2 295.4L551 311C551.3 310.9 551.6 311 551.8 311.2C552 311.4 552 311.7 551.8 311.9L560 321.2C560.2 321.5 560.2 321.8 559.9 322C559.7 322 559.5 322 559.4 322ZM537.2 297.3L536.2 320.2L549.7 311.5L537.2 297.3Z"
                fill="#042D48"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M543.3 315.7H528.8L521.5 295.6H536L543.3 315.7Z"
                fill="#3FADD1"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M544.7 322C544.5 322 544.3 321.9 544.1 321.8L535.9 312.5L521.2 321.9C521 322 520.7 322.1 520.5 322C520.3 321.9 520.1 321.7 520.1 321.5L521.2 295.7C521.2 295.4 521.4 295.2 521.7 295.2C522 295.1 522.3 295.2 522.5 295.4L536.3 311C536.6 310.9 536.9 311 537.1 311.2C537.3 311.4 537.3 311.7 537.1 311.9L545.3 321.2C545.5 321.5 545.5 321.8 545.2 322C545 322 544.8 322 544.7 322ZM522.5 297.3L521.5 320.2L535 311.5L522.5 297.3Z"
                fill="#0D4C6B"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M550.7 311.6H536.1C536 311.6 536 311.6 535.9 311.6L528.6 315.6C528.5 315.7 528.4 315.8 528.5 315.9C528.5 316 528.7 316.1 528.8 316.1H543.3C543.4 316.1 545.4 316.1 543.5 316.1L550.8 312.1C550.9 312 551 311.9 550.9 311.8C550.9 311.6 550.8 311.6 550.7 311.6Z"
                fill="#0D4C6B"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M565.3 321.9C565 321.7 565 321.4 565.2 321.2L571.9 313.6C571.8 313.4 571.8 313.2 571.9 313C572 312.8 572.3 312.8 572.5 312.8L583.6 300.1C583.7 299.9 584 299.9 584.2 299.9C584.4 300 584.6 300.1 584.6 300.3L585.5 321.3C585.5 321.5 585.4 321.7 585.2 321.7C585 321.8 584.8 321.8 584.6 321.7L572.7 314L566.1 321.6C566 321.7 565.8 321.8 565.6 321.8C565.5 322 565.4 322 565.3 321.9ZM573.4 313.5L584.3 320.6L583.5 302L573.4 313.5Z"
                fill="#042D48"
              ></path>
              <path
                d="M600.6 295.7H573.2V321.9H600.6V295.7Z"
                fill="#26C6DA"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M576.9 321.9C576.6 321.7 576.6 321.4 576.8 321.2L583.5 313.6C583.4 313.4 583.4 313.2 583.5 313C583.6 312.8 583.9 312.8 584.1 312.8L595.2 300.1C595.3 299.9 595.6 299.9 595.8 299.9C596 300 596.2 300.1 596.2 300.3L597.1 321.3C597.1 321.5 597 321.7 596.8 321.7C596.6 321.8 596.4 321.8 596.2 321.7L584.3 314L577.7 321.6C577.6 321.7 577.4 321.8 577.2 321.8C577.1 322 577 322 576.9 321.9ZM585 313.5L595.9 320.6L595.1 302L585 313.5Z"
                fill="#0D4C6B"
              ></path>
              <path d="M595 308.4H567V321.9H595V308.4Z" fill="#0D4C6B"></path>
              <path
                d="M483 321.3C482.4 321.3 481.8 320.9 481.6 320.2C476.3 303.1 479.1 289.8 482.5 281.6C486.1 272.7 490.9 267.9 491.1 267.7C491.7 267.1 492.6 267.1 493.2 267.7C493.8 268.3 493.8 269.2 493.2 269.8C493 270 474.9 288.3 484.5 319.2C484.7 320 484.3 320.8 483.5 321.1C483.3 321.3 483.1 321.3 483 321.3Z"
                fill="#9C6F47"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M512.4 264.6C511.7 263.7 504.5 261.9 498.7 263.6C495.9 264.4 493.4 265.4 491.8 266.3C490.5 265.2 487.3 263.8 483.3 262.6C477.5 260.9 470.3 262.7 469.6 263.6C468.9 264.5 474.8 264.3 480.6 266L484.5 267.3L480.8 269.1C474.9 270.6 472 275.4 472.5 276.5C473 277.6 476.9 274.5 482.7 273C486.2 272.1 489.2 271 490.9 270C492.6 271 495.6 272.1 499.1 273C505 274.5 508.8 277.6 509.3 276.5C509.8 275.4 506.9 270.5 501 269.1C499.4 268.7 497.8 268.4 496.3 268.2C497.8 267.9 499.5 267.5 501.2 267C507.1 265.3 513.1 265.6 512.4 264.6Z"
                fill="#6ECA84"
              ></path>
              <path
                d="M496.2 321.4C495.5 321.4 494.9 320.9 494.7 320.2C489.9 296.2 501.4 281.6 501.9 281C502.4 280.4 503.4 280.3 504 280.8C504.6 281.3 504.7 282.3 504.2 282.9C504 283.1 493.1 297.1 497.6 319.6C497.8 320.4 497.2 321.2 496.4 321.4C496.4 321.4 496.3 321.4 496.2 321.4Z"
                fill="#9C6F47"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M520.1 277.6C519.6 276.7 514.3 274.9 510 276.6C508.2 277.3 503.7 278.3 503.7 278.3C503.7 278.3 500.4 277.4 498.3 276.6C494 274.9 488.7 276.7 488.2 277.6C487.7 278.5 491.7 278.3 495.7 279.8C495.3 279.9 494.8 280.1 494.4 280.2C490 281.7 487.8 286.5 488.2 287.6C488.6 288.7 491.5 285.6 495.9 284.1C498.2 283.3 502.8 281.9 503.4 281.8C503.4 281.8 508.3 283.4 510.4 284.1C514.8 285.6 517.7 288.7 518.1 287.6C518.5 286.5 516.3 281.6 511.9 280.2C511.8 280.2 511.8 280.2 511.7 280.1C511.8 280.1 511.9 280 512 280C516.2 278.3 520.6 278.6 520.1 277.6Z"
                fill="#6ECA84"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M535.4 259.8C536 259.8 536.5 259.9 537 260.1C537 260 537 259.9 537 259.8C537 256 539.5 253 542.6 253C544.7 253 546.5 254.4 547.5 256.6C547.8 256.5 548 256.5 548.3 256.5C550.6 256.5 552.6 258.3 553.4 260.8C554.1 260.2 555 259.8 555.9 259.8C558.2 259.8 560.1 262.1 560.1 265H530.1C530.6 262 532.8 259.8 535.4 259.8Z"
                fill="#E5E5E5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M202.333 52L203.133 85.3333H185L192.067 52H202.333Z"
                fill="black"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M231 52L241 85.3333H202.467L192.467 52H231Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M231 52L232.467 56.6667H193.933L192.467 52H231Z"
                fill="#E04C3F"
              ></path>
              <path
                d="M223.933 55.3335H227.4C227.933 55.3335 228.2 54.9335 228.067 54.4001C227.933 53.8668 227.4 53.4668 227 53.4668H223.533C223 53.4668 222.733 53.8668 222.867 54.4001C223 54.9335 223.4 55.3335 223.933 55.3335Z"
                fill="white"
              ></path>
              <path
                d="M198.6 55.3335H202.067C202.6 55.3335 202.867 54.9335 202.733 54.4001C202.6 53.8668 202.067 53.4668 201.667 53.4668H198.2C197.667 53.4668 197.4 53.8668 197.533 54.4001C197.667 54.9335 198.2 55.3335 198.6 55.3335Z"
                fill="white"
              ></path>
              <path
                d="M224.6 78.1335H220.867L217.4 61.3335C217.4 61.0668 217.134 60.9335 216.867 60.8001C216.6 60.8001 216.334 60.8001 216.2 61.0668L213.667 64.0001C213.4 64.2668 213.4 64.6668 213.8 64.9335C214.067 65.2001 214.467 65.2001 214.734 64.8001L216.334 62.8001L219.534 77.8668H216.067C215.667 77.8668 215.4 78.1335 215.4 78.5335C215.4 78.9335 215.667 79.2001 216.067 79.2001H224.6C225 79.2001 225.267 78.9335 225.267 78.5335C225.267 78.4001 225 78.1335 224.6 78.1335Z"
                fill="black"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M587.5 125.5C584 123 584.7 130 583 132.4L582.8 175.9C586.2 172.3 590.7 167.5 593.4 163.5C592.9 157.4 592.7 151 592.8 144.2C591.6 133.3 589.8 127.1 587.5 125.5Z"
                fill="#1FB7CA"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M563.9 112.4L574.5 113.7V111.2L563.9 112.4Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M587.3 137.3C587.5 137.4 595.8 143.9 595.8 143.9L588.6 152.2L587.3 137.3Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M561.9 67.2C561.9 67.2 562 70 561.2 72C560.6 73.4 559.3 74.6 559.3 77C559.3 79.8 561.2 82.4 563.7 82.4C566.3 82.4 568.7 80.1 568.7 75.6C568.7 69.9 563.8 65 563.8 65C563.8 65 564.4 67.2 564.4 68.4C564.4 69.6 563.7 71.1 563.7 71.1C563.7 71.1 563.3 68 561.9 67.2Z"
                fill="#F7971C"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M563.7 72.9C563.7 72.9 564.3 74.3 562.6 75.6C562 76.1 561.6 76.8 561.6 77.7C561.6 79.1 562.7 80.3 564 80.3C565.3 80.3 566.4 79.1 566.4 77.7C566.4 75.7 565.1 74.1 563.7 72.9Z"
                fill="#E04C3F"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M563.9 76.6C563.9 76.6 564.2 77.3 563.4 78C563.1 78.2 562.9 78.6 562.9 79.1C562.9 79.8 563.4 80.4 564.1 80.4C564.8 80.4 565.3 79.8 565.3 79.1C565.2 78 564.6 77.2 563.9 76.6Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M569.4 139.4C568.5 139.4 567.7 138.9 567.1 138.1C566.5 137.2 561.5 128.7 561.5 117.3L562.1 99.3C562.1 97.7 562.8 97.1 564.2 97.1C565.7 97.1 566.4 98.1 566.4 99.7L566.9 117.3C566.9 125.2 569.9 132.1 571.7 135C572.5 136.3 572.2 138.1 570.9 139C570.5 139.2 570 139.4 569.4 139.4Z"
                fill="#115C65"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M596 159.6L586.3 154.6L594.3 137.3L604 142.3L596 159.6Z"
                fill="#115C65"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M568.6 123.6L576.9 116.4L576.1 115.7L575.4 114.9L568.6 123.6Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M582.8 123.5C584.6 123.9 585.4 124.9 585.4 124.9C585.4 124.9 587.1 136.8 587.8 145.1C588.5 153.4 592.2 196.9 592.2 196.9H563.7C563.7 196.9 565.2 170.8 565.6 165.9C566 161 567.4 141.9 567.4 141.9C567.4 141.9 562.1 127.5 561.5 125.3C564.7 122.4 569.4 118.7 569.4 118.7L574.3 123.6C574.3 123.6 575.1 122.9 577.9 122.9C578 122.8 581.1 123.1 582.8 123.5Z"
                fill="#26C6DA"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M587.8 145.1C588.5 153.4 592.2 196.9 592.2 196.9H563.7"
                fill="#115C65"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M589.6 166.4L590.4 176.4L563.7 196.9C563.7 196.9 563.8 195.7 563.9 193.2L589.6 166.4Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M564 193.2C570 188.3 581.9 177.8 589.7 166.4L588.1 145.2C587.4 136.9 585.8 124.9 585.8 124.9C585.8 124.9 584.6 123.6 582.9 123.2C581.1 122.8 578.3 122.8 578.3 122.8C575.5 122.8 574.7 123.5 574.7 123.5L569.7 118.6C569.7 118.6 564.9 122.4 561.7 125.3C562.3 127.5 567.6 141.9 567.6 141.9C567.6 141.9 566.2 161 565.8 166C565.3 169.7 564.4 185.7 564 193.2Z"
                fill="#26C6DA"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M586.2 124.8H585.7L581 132.3C581 132.3 570.9 143.6 566.8 149.1C566.7 150.5 566.2 157.8 566.2 157.8C566.2 157.8 576.6 146.4 579.3 142.7C581.7 139.4 586.9 127.4 586.9 127.4C586.8 127 586.9 127 586.9 126.8C586.7 125.2 586.6 125.1 586.2 124.8Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M587.1 135.7L586.8 133.5C584.8 139.7 583.2 144.7 580.4 148.4C576.3 154 568.6 161.4 565.7 163.9C565.6 164.9 565.5 166.9 565.3 170.1C573.2 159.7 578 153.3 579.8 150.8C582.2 147.6 587.4 135.9 587.1 135.7Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M579 128.9C581 128.9 582.5 127 582.5 124.6V123.4C580.8 123.1 579 122.9 579 122.9C577 122.9 575.9 123.3 575.5 123.5V124.6C575.5 127 577 128.9 579 128.9Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M579 117.4C577.7 117.4 576.6 118.6 576.6 120.1V125C576.6 126.5 577.7 127.9 579 127.9V117.4Z"
                fill="#26C6DA"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M589.8 123.6L581.6 116.4L582.3 115.7L583.1 114.9L589.8 123.6Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M583.7 117.5C583.7 120.2 581.6 122.4 579 122.4C576.4 122.4 574.3 120.2 574.3 117.5V113.6C574.3 110.9 576.4 108.7 579 108.7C581.6 108.7 583.7 110.9 583.7 113.6V117.5Z"
                fill="#26C6DA"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M579 97.5L577.8 108.7H579H580.2L579 97.5Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M567.4 101.2L574.2 109.9L575 109.2L575.7 108.4L567.4 101.2Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M574.3 117.4C574.2 114.6 574.3 113.6 574.3 113.6C574.3 113.6 576.5 109.8 579 111.8C579 111.8 578.5 115.6 574.3 117.4Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M591 101.2L584.2 109.9L583.5 109.2L582.8 108.4L591 101.2Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M593.4 112.4L583.9 113.7V112.4V111.2L593.4 112.4Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M579 111.8V127.9C580.3 127.9 581.4 126.5 581.4 125L581.5 121.6C582.9 120.7 583.8 119.1 583.8 117.3V116.7C583.8 114 581.6 111.8 579 111.8Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M579 111.8C579 111.8 579.7 115.8 583.9 117.6C584 114.8 583.8 113.6 583.8 113.6C583.8 113.6 581.5 109.7 579 111.8Z"
                fill="#C9C9C9"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M579 107.4C575.1 107.4 573.1 109.7 573.1 112.6C573.1 116.6 574.3 117.4 574.3 117.4C574.3 113.8 576.1 112.2 579 112.2C582 112.2 584 113.5 584 117.1C584 117.1 584.9 116.7 584.9 112.7C584.9 109.8 582.9 107.4 579 107.4Z"
                fill="#26C6DA"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M579 109C575.4 109 573.2 111 573.1 115.1C573.4 117.2 574.3 117.8 574.3 117.8C574.3 114.1 576 112.2 579 112.2C582 112.2 583.9 114 583.9 117.6C583.9 117.6 584.6 117.1 584.9 115C584.8 111 582.6 109 579 109Z"
                fill="#313131"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M600 155.1C599.6 155.9 598.7 156.1 597.9 155.7C597.1 155.3 596.8 154.3 597.1 153.6L598.6 150.5C599 149.7 599.9 149.5 600.7 149.9C601.5 150.3 601.8 151.3 601.5 152L600 155.1Z"
                fill="#26C6DA"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M563 88.4V102.1C563 102.8 563.4 103.3 564 103.3V87.1C563.5 87.2 563 87.7 563 88.4Z"
                fill="#C9C9C9"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M565 102.1V88.4C565 87.7 564.6 87.2 564 87.2V103.4C564.5 103.3 565 102.8 565 102.1Z"
                fill="#313131"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M569.6 82.9H558.4C557.6 82.9 557 83.6 557 84.4H571C571 83.6 570.4 82.9 569.6 82.9Z"
                fill="#C9C9C9"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M566.3 97.6C566.3 98.7 565.5 99.7 564.6 99.7H563.3C562.4 99.7 561.6 98.8 561.6 97.6V93C561.6 91.9 562.4 90.9 563.3 90.9H564.6C565.5 90.9 566.3 91.8 566.3 93V97.6Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M561.6 85.9H564V90.9H563.1L561.6 85.9Z"
                fill="#C9C9C9"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M564.9 135L574.4 123.5L567.4 141.9L564.9 135Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M566.4 85.9H564V90.9H564.9L566.4 85.9Z"
                fill="#313131"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M558.4 85.9H569.6C570.4 85.9 571 85.2 571 84.4H557C557 85.2 557.6 85.9 558.4 85.9Z"
                fill="#313131"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M588.8 155.3C588.5 152 588.7 152.8 588.4 150.3C580.4 164 570.6 173.2 564.8 177.9C564.7 179.7 564.6 181.6 564.5 183.5C574.4 172.5 583.6 160.6 588.8 155.3Z"
                fill="#21919E"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M177 152.9V155.5H199L199.1 152.9L200.9 145.5L201.8 142L203.8 134H197.2C196.2 134 195.3 134.4 194.6 135.2L184 148.2L182.5 150L181.7 151C180.8 152.2 179.4 152.8 177.9 152.8H177V152.9Z"
                fill="#25C1D5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M194.3 152.7H106.7C102.4 152.7 99.8 152.9 97 154C94.2 155.1 93.3 156.6 90.9 157.9C88.5 159.1 86 160.2 86 162.5C86 164.8 88.3 166.5 91.6 167.5C94.8 168.5 97.5 169.2 104.3 169.2H166.8C170.4 169.2 173.9 168.5 177.2 167.2L201.4 157.1C201.8 156.9 202 156.6 202 156.2V154C202 153.5 201.6 153.1 201.2 153L194.3 152.7Z"
                fill="#EEEEEE"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M162.3 157.9C162.8 157.9 163.1 157.5 163.1 157.1V156.3C163.1 155.8 162.7 155.5 162.3 155.5C161.9 155.5 161.5 155.9 161.5 156.3V157.1C161.5 157.5 161.8 157.9 162.3 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M165.3 157.9C165.8 157.9 166.1 157.5 166.1 157.1V156.3C166.1 155.8 165.7 155.5 165.3 155.5C164.8 155.5 164.5 155.9 164.5 156.3V157.1C164.5 157.5 164.8 157.9 165.3 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M168.3 157.9C168.8 157.9 169.1 157.5 169.1 157.1V156.3C169.1 155.8 168.7 155.5 168.3 155.5C167.9 155.5 167.5 155.9 167.5 156.3V157.1C167.5 157.5 167.8 157.9 168.3 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M171.3 157.9C171.8 157.9 172.1 157.5 172.1 157.1V156.3C172.1 155.8 171.7 155.5 171.3 155.5C170.8 155.5 170.5 155.9 170.5 156.3V157.1C170.5 157.5 170.9 157.9 171.3 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M114.2 157.9C114.7 157.9 115 157.5 115 157.1V156.3C115 155.8 114.6 155.5 114.2 155.5C113.7 155.5 113.4 155.9 113.4 156.3V157.1C113.4 157.5 113.7 157.9 114.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M117.2 157.9C117.7 157.9 118 157.5 118 157.1V156.3C118 155.8 117.6 155.5 117.2 155.5C116.8 155.5 116.4 155.9 116.4 156.3V157.1C116.4 157.5 116.7 157.9 117.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M111.2 157.9C111.7 157.9 112 157.5 112 157.1V156.3C112 155.8 111.6 155.5 111.2 155.5C110.7 155.5 110.4 155.9 110.4 156.3V157.1C110.4 157.5 110.7 157.9 111.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M120.2 157.9C120.7 157.9 121 157.5 121 157.1V156.3C121 155.8 120.6 155.5 120.2 155.5C119.7 155.5 119.4 155.9 119.4 156.3V157.1C119.4 157.5 119.7 157.9 120.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M123.2 157.9C123.7 157.9 124 157.5 124 157.1V156.3C124 155.8 123.6 155.5 123.2 155.5C122.8 155.5 122.4 155.9 122.4 156.3V157.1C122.4 157.5 122.7 157.9 123.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M126.2 157.9C126.6 157.9 127 157.5 127 157.1V156.3C127 155.8 126.6 155.5 126.2 155.5C125.7 155.5 125.4 155.9 125.4 156.3V157.1C125.4 157.5 125.8 157.9 126.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M129.2 157.9C129.7 157.9 130 157.5 130 157.1V156.3C130 155.8 129.6 155.5 129.2 155.5C128.7 155.5 128.4 155.9 128.4 156.3V157.1C128.4 157.5 128.8 157.9 129.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M132.2 157.9C132.7 157.9 133 157.5 133 157.1V156.3C133 155.8 132.6 155.5 132.2 155.5C131.7 155.5 131.4 155.9 131.4 156.3V157.1C131.4 157.5 131.8 157.9 132.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M135.2 157.9C135.6 157.9 136 157.5 136 157.1V156.3C136 155.8 135.6 155.5 135.2 155.5C134.7 155.5 134.4 155.9 134.4 156.3V157.1C134.4 157.5 134.8 157.9 135.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M138.2 157.9C138.6 157.9 139 157.5 139 157.1V156.3C139 155.8 138.6 155.5 138.2 155.5C137.7 155.5 137.4 155.9 137.4 156.3V157.1C137.4 157.5 137.8 157.9 138.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M141.2 157.9C141.6 157.9 142 157.5 142 157.1V156.3C142 155.8 141.6 155.5 141.2 155.5C140.7 155.5 140.4 155.9 140.4 156.3V157.1C140.4 157.5 140.8 157.9 141.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M144.2 157.9C144.7 157.9 145 157.5 145 157.1V156.3C145 155.8 144.6 155.5 144.2 155.5C143.7 155.5 143.4 155.9 143.4 156.3V157.1C143.4 157.5 143.8 157.9 144.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M147.2 157.9C147.7 157.9 148 157.5 148 157.1V156.3C148 155.8 147.6 155.5 147.2 155.5C146.7 155.5 146.4 155.9 146.4 156.3V157.1C146.4 157.5 146.8 157.9 147.2 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M150.3 157.9C150.8 157.9 151.1 157.5 151.1 157.1V156.3C151.1 155.8 150.7 155.5 150.3 155.5C149.8 155.5 149.5 155.9 149.5 156.3V157.1C149.4 157.5 149.8 157.9 150.3 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M153.3 157.9C153.8 157.9 154.1 157.5 154.1 157.1V156.3C154.1 155.8 153.7 155.5 153.3 155.5C152.9 155.5 152.5 155.9 152.5 156.3V157.1C152.4 157.5 152.8 157.9 153.3 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M156.3 157.9C156.8 157.9 157.1 157.5 157.1 157.1V156.3C157.1 155.8 156.7 155.5 156.3 155.5C155.9 155.5 155.5 155.9 155.5 156.3V157.1C155.5 157.5 155.8 157.9 156.3 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M159.3 157.9C159.8 157.9 160.1 157.5 160.1 157.1V156.3C160.1 155.8 159.7 155.5 159.3 155.5C158.8 155.5 158.5 155.9 158.5 156.3V157.1C158.5 157.5 158.8 157.9 159.3 157.9Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M91.1001 157.8H95.8001C96.1001 157.8 96.4001 157.7 96.6001 157.5C96.8001 157.3 96.9001 157 96.9001 156.7C96.9001 156 96.4001 155.5 95.7001 155.5H94.4001C93.8001 155.9 93.3001 156.3 92.8001 156.7C92.4001 157.1 91.8001 157.5 91.1001 157.8Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M98.6001 156.3V157.1C98.6001 157.6 99.0001 157.9 99.4001 157.9C99.9001 157.9 100.2 157.5 100.2 157.1V156.3C100.2 155.9 99.8001 155.5 99.4001 155.5C99.2001 155.5 99.0001 155.6 98.8001 155.7C98.7001 155.8 98.6001 156 98.6001 156.3Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M120.7 163.8H152.8C154.3 163.8 155.5 165 155.5 166.5C155.5 168 154.3 169.2 152.8 169.2H120.7C119.2 169.2 118 168 118 166.5C118 165 119.2 163.8 120.7 163.8Z"
                fill="#25C1D5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M122.1 165.7L165 158.5C165.5 158.4 166.1 158.3 166.6 158.3C169.9 157.8 172.7 155.9 174.1 154.8C174.8 154.3 175.6 154 176.5 154L175.7 156C175.1 157.4 173.9 158.6 172.5 159.2L152.3 167.5H122.4C122 167.5 121.6 167.2 121.5 166.8C121.3 166.2 121.6 165.7 122.1 165.7Z"
                fill="#F7971C"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M122.9 167V174.1C122.9 174.8 123.4 175.3 124.1 175.3H129.2C133 175.3 136.9 174.7 139.8 174C140.9 173.8 141.9 173.5 142.7 173.3C143.1 173.2 143.5 173.1 143.8 173V168C143.5 167.9 143.1 167.8 142.7 167.7C141.9 167.5 140.9 167.3 139.8 167C136.9 166.4 133 165.7 129.2 165.7H124.1C123.5 165.8 122.9 166.3 122.9 167Z"
                fill="#66CA88"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M142.8 167.7V173.3C143.2 173.2 143.6 173.1 143.9 173V168C143.5 167.9 143.2 167.8 142.8 167.7Z"
                fill="#25C1D5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M139.9 167.1V174C141 173.8 142 173.5 142.8 173.3V167.7C142 167.5 141 167.3 139.9 167.1Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M122.9 167V174.1C122.9 174.8 123.4 175.3 124.1 175.3H124.7V165.8H124.1C123.5 165.8 122.9 166.3 122.9 167Z"
                fill="#0782C5"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M200 152.8V157.5L201.2 157C201.6 156.9 201.8 156.5 201.8 156.1V156V153.8C201.8 153.7 201.8 153.7 201.8 153.7C201.7 153.3 201.4 152.9 201 152.8H200Z"
                fill="#25C1D5"
              ></path>
              <path
                d="M30 93H26C26 70.1 21.3 61.5 11.6 53.5C3.90001 47.2 0 38.5 0 27.8C0 13 12.6 1 28 1C43.2 1 55.7 12.8 56 27.3V27.7C56 38.4 52.1 47.1 44.4 53.4C34.7 61.5 30 70.1 30 93Z"
                fill="#5FC782"
              ></path>
              <path
                d="M28 10C17.5 10 9 18.5 9 29C9 39.5 17.5 48 28 48C38.5 48 47 39.5 47 29C47 18.5 38.5 10 28 10Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.1999 22.9C22.1999 22.9 22.9999 22.7 24.2999 23.1C25.1999 23.4 26.8999 23.9 28.2999 24.3L23.9999 26.3L21.4999 23.8C21.4999 23.8 20.9999 23.4 21.3999 23.2C21.8999 23 22.1999 22.9 22.1999 22.9ZM37.0999 21.4C37.6999 21.4 38.1999 21.5 38.6999 21.9C38.8999 22 39.0999 22.2 39.1999 22.5C39.4999 23 38.4999 23.8 38.2999 23.9C37.6999 24.4 36.9999 24.8 32.7999 26.8H32.6999C31.8999 28.5 29.4999 34.1 29.1999 34.7C28.8999 35.5 27.7999 36.3 27.2999 36.5C26.8999 36.6 26.8999 36.2 26.8999 36.2L26.0999 29.6C25.7999 29.7 25.3999 29.8 25.0999 29.9H24.9999C24.6999 30 24.3999 30.1 24.1999 30.2C24.0999 30.2 23.8999 30.3 23.7999 30.3H23.6999C23.4999 30.4 23.2999 30.4 23.0999 30.5C22.9999 30.5 22.9999 30.5 22.8999 30.6C22.7999 30.6 22.5999 30.7 22.4999 30.7C22.3999 30.7 22.2999 30.8 22.1999 30.8C22.0999 30.8 21.9999 30.8 21.9999 30.9C21.8999 30.9 21.7999 31 21.5999 31C21.4999 31 21.4999 31 21.3999 31C21.2999 31 21.1999 31 21.0999 31.1H20.9999C20.8999 31.1 20.6999 31.1 20.5999 31.2H20.4999C20.3999 31.2 20.1999 31.2 20.0999 31.2C19.2999 31 18.5999 29.8 18.5999 29.8C18.5999 29.8 16.9999 27.1 16.8999 26.9C16.8999 26.7 16.8999 26.5 17.0999 26.4C17.1999 26.4 17.1999 26.4 17.2999 26.3C17.3999 26.3 17.3999 26.3 17.4999 26.3C17.4999 26.3 17.6999 26.3 17.7999 26.3H17.8999C17.9999 26.3 17.9999 26.3 18.0999 26.4L18.1999 26.5C18.1999 26.5 18.5999 26.7 18.6999 26.8C18.8999 26.9 18.7999 26.9 18.8999 26.9C18.8999 26.9 18.8999 26.9 18.9999 26.9C19.0999 27 19.1999 27 19.2999 27.1C19.2999 27.1 19.2999 27.1 19.3999 27.1C19.4999 27.2 19.5999 27.2 19.5999 27.3C19.5999 27.3 19.6999 27.3 19.6999 27.4C19.7999 27.5 19.8999 27.6 20.0999 27.7C20.0999 27.7 20.1999 27.8 20.2999 27.9C20.3999 28 20.5999 28.1 20.6999 28.2H20.7999C20.7999 28.2 20.7999 28.2 20.8999 28.2C20.8999 28.2 20.8999 28.2 20.9999 28.2H21.0999L24.6999 26.5L34.7999 21.8C34.6999 22 35.8999 21.4 37.0999 21.4Z"
                fill="black"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M154.8 307.8H152.6C150.1 307.8 148.1 310.7 148.1 314.2C148.1 317.7 150.1 320.6 152.6 320.6H154.8C157.3 320.6 159.3 317.7 159.3 314.2C159.2 310.7 157.2 307.8 154.8 307.8Z"
                fill="black"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M113.1 307.8H110.9C108.4 307.8 106.4 310.7 106.4 314.2C106.4 317.7 108.4 320.6 110.9 320.6H113.1C115.6 320.6 117.6 317.7 117.6 314.2C117.6 310.7 115.6 307.8 113.1 307.8Z"
                fill="black"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M144.6 304.6L148.3 304.3C149 304.2 149.5 303.7 149.5 303C149.5 302.3 149 301.7 148.3 301.7L146.1 301.5C145.3 301.4 144.6 302.1 144.6 302.8V304.6Z"
                fill="#F7971C"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M148.3 304.3L146.6 304.4C146.6 303.9 147 303.5 147.5 303.5H149.4C149.1 303.9 148.7 304.2 148.3 304.3Z"
                fill="#F7971C"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M124.5 295H125.2H127.9C137 295 148.1 302.7 148.1 302.7L160.4 307.4C162.1 308.1 163.3 310.3 163.3 312.9V318.1H155.7H113.9L107.7 295H124.5Z"
                fill="#F7971C"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M127.8 296.1H111.6V302.6H145.7C142.4 300.5 134.5 296.1 127.8 296.1Z"
                fill="#41B7CB"
              ></path>
              <path
                d="M101.8 306.9H89.1001V318.1H101.8V306.9Z"
                fill="black"
              ></path>
              <path
                d="M136.8 306.9H124.1V318.1H136.8V306.9Z"
                fill="black"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M96.7 320.7C99.2 320.7 101.2 317.8 101.2 314.3C101.2 310.8 99.2 307.9 96.7 307.9H94.5V320.7H96.7Z"
                fill="black"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M99 314.3C99 317.8 97 320.7 94.5 320.7C92 320.7 90 317.8 90 314.3C90 310.8 92 307.9 94.5 307.9C97 307.9 99 310.7 99 314.3Z"
                fill="#333333"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M97.5 314.3C97.5 316.7 96.2 318.6 94.5 318.6C92.9 318.6 91.5 316.7 91.5 314.3C91.5 311.9 92.8 310 94.5 310C96.1 310 97.5 311.9 97.5 314.3Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M133.4 320.7C135.9 320.7 137.9 317.8 137.9 314.3C137.9 310.8 135.9 307.9 133.4 307.9H131.2V320.7H133.4Z"
                fill="black"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M135.6 314.3C135.6 317.8 133.6 320.7 131.1 320.7C128.6 320.7 126.6 317.8 126.6 314.3C126.6 310.8 128.6 307.9 131.1 307.9C133.6 307.9 135.6 310.7 135.6 314.3Z"
                fill="#333333"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M134.1 314.3C134.1 316.7 132.8 318.6 131.1 318.6C129.5 318.6 128.1 316.7 128.1 314.3C128.1 311.9 129.4 310 131.1 310C132.8 310 134.1 311.9 134.1 314.3Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M140.1 307.4L127.8 302.7C127.8 302.7 116.8 295 107.6 295H105H104.3C96.1 295 85.1 300.5 85.1 300.5V308.4C83.8 310.3 83 312.9 83 315.6V318.1H89.1V314.3C89.1 310.5 91.3 307.3 93.9 307.3C96.6 307.3 98.7 310.4 98.7 314.3V318.1H125.7V314.3C125.7 310.5 127.9 307.3 130.5 307.3C133.2 307.3 135.3 310.4 135.3 314.3V318.1H142.9V312.9C143 310.4 141.8 308.1 140.1 307.4Z"
                fill="#F7971C"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M107.6 296.1H104.2C99.8999 296.1 94.5999 297.7 90.7999 299.2C90.0999 299.5 89.7999 300.3 90.1999 300.9L91.7999 303.6H125.3C125.8 303.6 126.1 302.9 125.6 302.6C122.3 300.6 114.4 296.1 107.6 296.1Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M85.1001 300.5L87.4001 302.6V304.6L85.1001 308.4V300.5Z"
                fill="#E04C3F"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M109.1 304.4H106.7L106 295.7H107.6L109.1 304.4Z"
                fill="#F7971C"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M93.3999 303.9H95.2999L95.7999 297.1H94.4999L93.3999 303.9Z"
                fill="#F7971C"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M124 304.6L120.3 304.3C119.6 304.2 119.1 303.7 119.1 303C119.1 302.3 119.6 301.7 120.3 301.7L122.5 301.5C123.3 301.4 124 302.1 124 302.8V304.6Z"
                fill="#F7971C"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M124.6 304.5L124 304H123.5C123.3 304 123.1 304.3 123.2 304.5L123.8 305.4C123.9 305.5 124.1 305.7 124.2 305.7C124.5 305.7 124.8 305.5 124.8 305.1V305C124.9 304.8 124.8 304.6 124.6 304.5Z"
                fill="#F7971C"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M144.4 310.3H139.1C138.2 310.3 137.4 310 136.8 309.4L135.8 308.5C135.4 308.1 135.7 307.4 136.2 307.4H141.5C142.4 307.4 143.2 307.7 143.8 308.3L144.8 309.2C145.3 309.6 145 310.3 144.4 310.3Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M161.1 307.9C160.9 308 160.8 308.1 160.6 308.3L159.6 309.2C159.2 309.6 159.5 310.3 160 310.3H162.6C162.4 309.3 161.9 308.5 161.1 307.9Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M142.5 315.2C142.5 315.6 142.2 316 141.8 316.1C141.4 316 141.1 315.6 141.1 315.2C141.1 314.8 141.4 314.4 141.8 314.3C142.2 314.4 142.5 314.8 142.5 315.2Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M161.6 315.2C161.6 315.6 161.3 316 160.9 316.1C160.5 316 160.2 315.6 160.2 315.2C160.2 314.8 160.5 314.4 160.9 314.3C161.3 314.4 161.6 314.8 161.6 315.2Z"
                fill="white"
              ></path>
              <path
                d="M28 90V273C28 300.614 50.3858 323 78 323H709M122 87L248 87C270.091 87 288 104.909 288 127V174M389 157V283C389 305.091 371.091 323 349 323H246M389 252V126C389 103.909 406.909 86 429 86H512M285 198H247C219.386 198 197 220.386 197 248V273C197 300.614 219.386 323 247 323H344M648 130C648 167.555 617.555 198 580 198C542.445 198 512 167.555 512 130V33"
                stroke="#DDDDDD"
                stroke-width="4"
              ></path>
              <path
                d="M648 144C659.598 144 669 134.598 669 123C669 111.402 659.598 102 648 102C636.402 102 627 111.402 627 123C627 134.598 636.402 144 648 144Z"
                fill="#209DB2"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M645.3 118.8C645.3 117.3 646.5 116 648 116C649.5 116 650.7 117.3 650.7 118.8C650.7 120.3 649.5 121.6 648 121.6C646.5 121.6 645.3 120.3 645.3 118.8ZM656.4 119.3C656.4 114.4 652.6 110.4 648 110.4C643.4 110.4 639.6 114.4 639.6 119.3C639.6 126 648 135.6 648 135.6C648 135.6 656.4 126 656.4 119.3Z"
                fill="white"
              ></path>
              <path
                d="M512 42C523.598 42 533 32.598 533 21C533 9.40202 523.598 0 512 0C500.402 0 491 9.40202 491 21C491 32.598 500.402 42 512 42Z"
                fill="#26C6DA"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M512.2 12.1C513.7 12.1 515 10.9 515 9.39999C515 7.89999 513.8 6.70001 512.2 6.70001C510.7 6.70001 509.4 7.89999 509.4 9.39999C509.4 10.9 510.7 12.1 512.2 12.1Z"
                fill="white"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M520.3 33L517.5 26.4C517.4 26.2 517.3 26 517.1 25.9L514.5 23.4V21.4L517.2 23.8C517.8 24.3 518.8 24.3 519.3 23.7C519.8 23.1 519.8 22.2 519.2 21.6L514.5 17.3V15.2C514.5 13.9 513.5 12.9 512.2 12.9H512.1C512 12.9 511.9 12.9 511.8 12.9C511.7 12.9 511.7 12.9 511.6 12.9H511.5H511.4C511.3 12.9 511.3 12.9 511.2 13L505.3 15.4C504.7 15.6 504.3 16.2 504.2 16.8L503.6 22C503.5 22.9 504.2 23.7 505.1 23.9C506 24 506.9 23.3 507 22.4L507.5 18.1L509.8 17.2V23.4C509.8 23.5 509.8 23.7 509.8 23.8L507.8 27.9L503.9 32.2C503.3 32.9 503.3 33.9 504 34.6C504.7 35.3 505.8 35.2 506.4 34.5L510.5 30.1C510.6 30 510.7 29.8 510.8 29.7L512.5 26.1L514.4 27.9L517 34.2C517.4 35.1 518.4 35.5 519.2 35.1C520.2 34.8 520.6 33.9 520.3 33Z"
                fill="white"
              ></path>
              <path
                d="M129 104C140.598 104 150 94.598 150 83C150 71.402 140.598 62 129 62C117.402 62 108 71.402 108 83C108 94.598 117.402 104 129 104Z"
                fill="#209DB2"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M126.1 77C126.1 77.1 126.1 77.1 126.1 77.2V78.4C126.1 79.1 125.5 80 124.7 80.4L123.8 80.8C123.7 80.8 123.7 80.8 123.6 80.9L123.8 95.7C123.8 96.3 123.1 96.5 122.5 96.5C121.9 96.5 121.2 96.2 121.2 95.7L121.4 80.9C121.3 80.9 121.3 80.9 121.2 80.8L120.3 80.4C119.5 80 118.9 79.1 118.9 78.4V77.2C118.9 77.1 118.9 77.1 118.9 77V76.9L119.3 70.2C119.3 69.9 119.5 69.6 119.6 69.6C119.8 69.6 119.9 69.9 119.9 70.2L120.2 75.9V76.4C120.2 76.7 120.5 77 120.9 77C121.3 77 121.6 76.7 121.6 76.4V75.9L121.9 70.2C121.9 69.9 122.1 69.6 122.2 69.6C122.4 69.6 122.5 69.9 122.5 70.2L122.8 75.9V76.4C122.8 76.7 123.1 77 123.5 77C123.9 77 124.2 76.7 124.2 76.4V75.9L124.5 70.3C124.5 70 124.7 69.7 124.8 69.7C124.9 69.7 125.1 70 125.1 70.3L125.5 77C126.1 76.9 126.1 77 126.1 77ZM138.8 75.2C138.8 72.1 136.8 69.6 134.3 69.6C131.8 69.6 129.8 72.1 129.8 75.2C129.8 77.8 131.2 80 133.2 80.7L133 95.5C133 96.1 133.8 96.3 134.4 96.3C135 96.3 135.8 96 135.8 95.5L135.6 80.7C137.4 80.1 138.8 77.9 138.8 75.2Z"
                fill="white"
              ></path>
              <path
                d="M286 211.333C297.598 211.333 307 201.931 307 190.333C307 178.735 297.598 169.333 286 169.333C274.402 169.333 265 178.735 265 190.333C265 201.931 274.402 211.333 286 211.333Z"
                fill="#E04C3F"
              ></path>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M299.3 185.633H296.8L295.3 182.733C294.5 181.233 292.9 180.233 291.3 180.233H280.8C279.1 180.233 277.6 181.233 276.8 182.733L275.3 185.633H272.8C272.2 185.633 271.7 185.933 271.7 186.433V187.733C271.7 188.333 272.2 188.733 272.8 188.733H273C272.9 188.933 272.8 189.133 272.8 189.333V196.533C272.8 197.633 273.5 198.633 274.5 198.833V199.333V199.433C274.5 200.133 275 200.633 275.7 200.633H278C278.6 200.633 279.2 200.133 279.2 199.433V199.333V198.933H293.1V199.333V199.433C293.1 200.133 293.6 200.633 294.3 200.633H296.6C297.2 200.633 297.8 200.133 297.8 199.433V199.333V198.833C298.8 198.533 299.5 197.633 299.5 196.533V189.333C299.5 189.133 299.4 188.933 299.3 188.733H299.5C300.1 188.733 300.6 188.333 300.6 187.733V186.333C300.4 185.933 299.9 185.633 299.3 185.633ZM297 194.033C297 195.033 296.2 195.833 295.3 195.833C294.4 195.833 293.6 195.033 293.6 194.033C293.6 193.033 294.4 192.233 295.3 192.233C296.2 192.233 297 193.033 297 194.033ZM277.2 185.533L278.3 183.733C279 182.633 280.3 181.833 281.6 181.833H290.3C291.7 181.833 293 182.533 293.6 183.733L294.7 185.533L295.9 187.633H276L277.2 185.533ZM276.8 192.233C277.8 192.233 278.5 193.033 278.5 194.033C278.5 195.033 277.7 195.833 276.8 195.833C275.9 195.833 275.1 195.033 275.1 194.033C275 193.033 275.8 192.233 276.8 192.233ZM288.9 194.633H283.1C282.8 194.633 282.5 194.333 282.5 194.033C282.5 193.733 282.8 193.433 283.1 193.433H288.9C289.2 193.433 289.5 193.733 289.5 194.033C289.5 194.333 289.2 194.633 288.9 194.633Z"
                fill="white"
              ></path>
              <rect
                x="672"
                y="302"
                width="40"
                height="40"
                rx="20"
                fill="#F7971C"
              ></rect>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M679.188 315.138C679.188 314.441 679.753 313.875 680.451 313.875C681.148 313.875 681.714 314.441 681.714 315.138V321.888H690.016C690.015 321.869 690.015 321.85 690.015 321.831C690.015 320.615 691 319.63 692.215 319.63H702.612C703.827 319.63 704.812 320.615 704.812 321.831C704.812 322.047 704.781 322.257 704.723 322.455C704.781 322.6 704.813 322.759 704.813 322.925V328.862C704.813 329.559 704.247 330.125 703.55 330.125C702.852 330.125 702.287 329.559 702.287 328.862V325.497H681.714V328.862C681.714 329.559 681.148 330.125 680.451 330.125C679.753 330.125 679.188 329.559 679.188 328.862V315.138ZM682.796 319.63C682.796 318.882 683.402 318.276 684.15 318.276H687.939C688.686 318.276 689.293 318.882 689.293 319.63C689.293 320.378 688.686 320.984 687.939 320.984H684.15C683.402 320.984 682.796 320.378 682.796 319.63Z"
                fill="white"
              ></path>
            </svg>
          </div>
          <span>
            <span className="text-xl font-semibold flex justify-center">
              Không Có Chuyến Đi Trước Đây
            </span>
            <br />

            <span className="flex justify-center ">
              Bạn đã lập chuyến đi cho kì nghĩ sắp tới chưa? Nếu có vấn đề trong
              việc lập kế hoạch hãy liên hệ với chúng tôi:
              <Link to={`/contact`}>
                <span className="text-blue pl-1 text-sky-500">
                  tiendung8a6@gmail.com.
                </span>
              </Link>
            </span>

            <span className="flex justify-center pt-3">
              Bạn cũng có thể tự tạo chuyến đi cho riêng minh.
            </span>
            <br />
            <Link to={`/trip/create`}>
              <span className="flex justify-center">
                <Button className="flex justify-center" variant="filled">
                  Thêm chuyến đi
                </Button>
              </span>
            </Link>
            <br />

            <br />
            <div className="max-w-[800px] mb-[10px] mx-auto bg-[#f6f6fa] px-[100px] pt-[35px]  ">
              <div className=" text-center text-xl font-medium ">
                Chúng tôi hỗ trợ các loại kế hoạch sau
              </div>
              <Grid className="max-w-[800px]  mx-auto bg-[#f6f6fa] px-[50px] pt-[20px]  ">
                <Grid.Col
                  className=""
                  align-items-center
                  span={{ base: 12, md: 6, lg: 6 }}
                >
                  <div className="flex  items-center gap-5 mt-[20px]">
                    <span className="bg-[#41b7cb] border-[#41b7cb] border-none rounded-full w-[40px] h-[40px] p-[2px]">
                      <IconPlane
                        stroke={2}
                        className="text-[white] m-[3px] h-[30px] w-[30px] "
                      />
                    </span>
                    <span>Chuyến bay</span>
                  </div>

                  <div className="flex  items-center gap-5 mt-[20px]">
                    <span className="bg-[#41b7cb] border-[#41b7cb] border-none rounded-full w-[40px] h-[40px] p-[2px]">
                      <IconBed
                        stroke={2}
                        className="text-[white] m-[3px] h-[30px] w-[30px] "
                      />
                    </span>
                    <span>Khách sạn, Nhà nghỉ</span>
                  </div>

                  <div className="flex  items-center gap-5 mt-[20px]">
                    <span className="bg-[#41b7cb] border-[#41b7cb] border-none rounded-full w-[40px] h-[40px] p-[2px]">
                      <IconCar
                        stroke={2}
                        className="text-[white] m-[3px] h-[30px] w-[30px] "
                      />
                    </span>
                    <span>Thuê xe ô tô</span>
                  </div>

                  <div className="flex  items-center gap-5 mt-[20px]">
                    <span className="bg-[#41b7cb] border-[#41b7cb] border-none rounded-full w-[40px] h-[40px] p-[2px]">
                      <IconSoup
                        stroke={2}
                        className="text-[white] m-[3px] h-[30px] w-[30px] "
                      />
                    </span>
                    <span>Đặt chỗ nhà hàng</span>
                  </div>

                  <div className="flex  items-center gap-5 mt-[20px]">
                    <span className="bg-[#41b7cb] border-[#41b7cb] border-none rounded-full w-[40px] h-[40px] p-[2px]">
                      <IconCalendarStats
                        stroke={2}
                        className="text-[white] m-[3px] h-[30px] w-[30px] "
                      />
                    </span>
                    <span>Cuộc họp</span>
                  </div>
                </Grid.Col>

                <Grid.Col
                  className=""
                  align-items-center
                  span={{ base: 12, md: 6, lg: 6 }}
                >
                  <div className="flex  items-center gap-5 mt-[20px]">
                    <span className="bg-[#41b7cb] border-[#41b7cb] border-none rounded-full w-[40px] h-[40px] p-[2px]">
                      <IconMapPinCheck
                        stroke={2}
                        className="text-[white] m-[3px] h-[30px] w-[30px] "
                      />
                    </span>
                    <span>Bản đồ và chỉ đường</span>
                  </div>

                  <div className="flex  items-center gap-5 mt-[20px]">
                    <span className="bg-[#41b7cb] border-[#41b7cb] border-none rounded-full w-[40px] h-[40px] p-[2px]">
                      <IconShip
                        stroke={2}
                        className="text-[white] m-[3px] h-[30px] w-[30px] "
                      />
                    </span>
                    <span>Vé du thuyền và phà</span>
                  </div>

                  <div className="flex  items-center gap-5 mt-[20px]">
                    <span className="bg-[#41b7cb] border-[#41b7cb] border-none rounded-full w-[40px] h-[40px] p-[2px]">
                      <IconWalk
                        stroke={2}
                        className="text-[white] m-[3px] h-[30px] w-[30px] "
                      />
                    </span>
                    <span>Các hoạt động</span>
                  </div>

                  <div className="flex  items-center gap-5 mt-[20px]">
                    <span className="bg-[#41b7cb] border-[#41b7cb] border-none rounded-full w-[40px] h-[40px] p-[2px]">
                      <IconParkingCircle
                        stroke={2}
                        className="text-[white] m-[3px] h-[30px] w-[30px] "
                      />
                    </span>
                    <span>Bãi đậu xe</span>
                  </div>

                  <div className="flex  items-center gap-5 mt-[20px]">
                    <span className="bg-[#41b7cb] border-[#41b7cb] border-none rounded-full w-[40px] h-[40px] p-[2px]">
                      <IconTrain
                        stroke={2}
                        className="text-[white] m-[3px] h-[30px] w-[30px] "
                      />
                    </span>
                    <span>Vé xe lửa</span>
                  </div>
                </Grid.Col>
              </Grid>
            </div>
          </span>
        </span>
      ) : (
        <div className="w-full flex flex-col md:flex-row gap-10 2xl:gap-20">
          <div className="w-full lg:w-full md:w-full flex flex-col gap-y-28 md:gap-y-14">
            {trips?.map((trip, index) => (
              <TripCard key={trip?._id} trip={trip} index={index} />
            ))}

            <div className="w-full flex items-center justify-center">
              <Pagination
                totalPages={numOfPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyTripsPanel;
